import { useState } from 'react';
import { Link } from 'react-router-dom';
import ServiceNavbar from './components/ServiceNavbar';
import Footer from '../home/components/Footer';

export default function ServicesPage() {
  const [activeFilter, setActiveFilter] = useState('all');

  const services = [
    {
      icon: 'ri-instagram-line',
      title: 'Social Media Management',
      description: 'Full-service management of your social channels including content creation, community engagement, and growth strategies that drive real results.',
      features: ['Content Calendar', 'Community Management', 'Growth Strategy', 'Brand Voice Development'],
      link: '/services/social-media-management',
      image: 'https://public.readdy.ai/ai/img_res/742b5765cc61d1da35c890706e7b16d8.jpg'
    },
    {
      icon: 'ri-video-line',
      title: 'Video & Reels Production',
      description: 'Scroll-stopping short-form video content optimized for Instagram Reels, TikTok, and YouTube Shorts that captures attention and drives engagement.',
      features: ['Concept Development', 'Professional Filming', 'Expert Editing', 'Trend Integration'],
      link: '/services/video-production',
      image: 'https://readdy.ai/api/search-image?query=Professional%20video%20production%20studio%20with%20camera%20equipment%20and%20ring%20lights%2C%20teal%20and%20mint%20green%20accents%2C%20modern%20creative%20workspace%20for%20social%20media%20content%20creation%2C%20clean%20aesthetic&width=600&height=400&seq=svc-video-1&orientation=landscape'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Influencer Marketing',
      description: 'Strategic partnerships with creators who authentically connect with your target audience, driving brand awareness and conversions.',
      features: ['Influencer Discovery', 'Campaign Management', 'Contract Negotiation', 'Performance Tracking'],
      link: '/services/influencer-marketing',
      image: 'https://readdy.ai/api/search-image?query=Influencer%20creating%20content%20with%20professional%20lighting%20setup%2C%20modern%20studio%20environment%20with%20teal%20accents%2C%20social%20media%20marketing%20aesthetic%2C%20authentic%20brand%20collaboration%20scene&width=600&height=400&seq=svc-inf-1&orientation=landscape'
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Paid Social Advertising',
      description: 'Data-driven ad campaigns across Meta, TikTok, LinkedIn, and Pinterest that maximize your ROI and reach your ideal customers.',
      features: ['Audience Targeting', 'Creative Development', 'A/B Testing', 'Budget Optimization'],
      link: '/services/paid-advertising',
      image: 'https://readdy.ai/api/search-image?query=Digital%20advertising%20dashboard%20on%20large%20monitor%20showing%20campaign%20metrics%20and%20graphs%2C%20modern%20marketing%20office%20with%20teal%20accent%20lighting%2C%20professional%20data%20analytics%20workspace&width=600&height=400&seq=svc-ads-1&orientation=landscape'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Content Strategy',
      description: 'Data-driven content planning that aligns with your business goals and resonates with your audience across all touchpoints.',
      features: ['Content Audits', 'Editorial Planning', 'Brand Guidelines', 'Content Pillars'],
      link: '/services/content-strategy',
      image: 'https://readdy.ai/api/search-image?query=Creative%20strategy%20session%20with%20mood%20boards%20and%20content%20calendars%20on%20wall%2C%20modern%20marketing%20agency%20workspace%20with%20teal%20accents%2C%20brainstorming%20environment%20with%20sticky%20notes&width=600&height=400&seq=svc-strat-1&orientation=landscape'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Analytics & Reporting',
      description: 'Comprehensive performance tracking and insights that inform strategy and demonstrate clear ROI on your marketing investment.',
      features: ['Custom Dashboards', 'Monthly Reports', 'Competitor Analysis', 'Growth Insights'],
      link: '/services/analytics-reporting',
      image: 'https://readdy.ai/api/search-image?query=Analytics%20dashboard%20with%20colorful%20charts%20and%20graphs%20on%20multiple%20screens%2C%20modern%20data%20analysis%20workspace%20with%20teal%20lighting%20accents%2C%20professional%20marketing%20metrics%20display&width=600&height=400&seq=svc-analytics-1&orientation=landscape'
    },
    {
      icon: 'ri-palette-line',
      title: 'Branding',
      description: 'Comprehensive brand identity development that captures your essence and creates lasting impressions across all customer touchpoints.',
      features: ['Logo Design', 'Brand Guidelines', 'Visual Identity', 'Brand Messaging'],
      link: '/services/branding',
      image: 'https://readdy.ai/api/search-image?query=Creative%20branding%20workspace%20with%20color%20palettes%20mood%20boards%20and%20logo%20sketches%20on%20desk%2C%20modern%20design%20studio%20with%20teal%20accent%20lighting%2C%20minimalist%20aesthetic%20with%20brand%20identity%20materials%20displayed%20professionally&width=600&height=400&seq=svc-brand-1&orientation=landscape'
    },
    {
      icon: 'ri-layout-line',
      title: 'Web Design',
      description: 'Beautiful, conversion-focused websites that deliver exceptional user experiences and drive business results across all devices.',
      features: ['Responsive Design', 'UX/UI Optimization', 'SEO Foundation', 'Performance Tuning'],
      link: '/services/web-design',
      image: 'https://readdy.ai/api/search-image?query=Modern%20web%20design%20workspace%20with%20multiple%20screens%20showing%20website%20mockups%20and%20wireframes%2C%20teal%20accent%20lighting%2C%20clean%20minimalist%20design%20studio%20aesthetic%20with%20plants%20and%20professional%20creative%20environment&width=600&height=400&seq=svc-web-1&orientation=landscape'
    }
  ];

  const stats = [
    { value: '150+', label: 'Brands Served' },
    { value: '500M+', label: 'Impressions Generated' },
    { value: '3.5x', label: 'Average ROI' },
    { value: '98%', label: 'Client Retention' }
  ];

  const portfolioItems = [
    {
      id: 1,
      title: 'Luxe Botanica Brand Launch',
      client: 'Luxe Botanica',
      category: 'branding',
      result: '340% increase in brand recognition',
      image: 'https://readdy.ai/api/search-image?query=elegant%20luxury%20skincare%20brand%20identity%20design%20with%20minimalist%20gold%20and%20cream%20packaging%20bottles%20displayed%20on%20marble%20surface%20with%20soft%20natural%20lighting%20professional%20product%20photography%20clean%20aesthetic&width=600&height=400&seq=port-svc-1&orientation=landscape'
    },
    {
      id: 2,
      title: 'TechFlow Digital Campaign',
      client: 'TechFlow Inc.',
      category: 'social-media',
      result: '2.5M impressions in 30 days',
      image: 'https://readdy.ai/api/search-image?query=modern%20tech%20company%20social%20media%20campaign%20mockup%20showing%20Instagram%20posts%20and%20stories%20on%20smartphone%20screens%20with%20teal%20accent%20colors%20professional%20marketing%20presentation%20clean%20background&width=600&height=400&seq=port-svc-2&orientation=landscape'
    },
    {
      id: 3,
      title: 'Artisan Coffee E-commerce',
      client: 'Artisan Coffee Co.',
      category: 'web-design',
      result: '180% increase in online sales',
      image: 'https://readdy.ai/api/search-image?query=artisan%20coffee%20shop%20website%20design%20mockup%20on%20laptop%20screen%20with%20warm%20earth%20tones%20beautiful%20product%20photography%20clean%20modern%20ecommerce%20layout%20professional%20presentation%20wooden%20desk&width=600&height=400&seq=port-svc-3&orientation=landscape'
    },
    {
      id: 4,
      title: 'Urban Fitness Video Series',
      client: 'Urban Fitness',
      category: 'video',
      result: '5M+ views across platforms',
      image: 'https://readdy.ai/api/search-image?query=fitness%20brand%20video%20content%20production%20behind%20the%20scenes%20with%20professional%20camera%20equipment%20gym%20setting%20dynamic%20lighting%20athletic%20models%20teal%20accent%20colors%20modern%20creative%20production&width=600&height=400&seq=port-svc-4&orientation=landscape'
    },
    {
      id: 5,
      title: 'Serenity Wellness Rebrand',
      client: 'Serenity Wellness',
      category: 'branding',
      result: '95% positive brand sentiment',
      image: 'https://readdy.ai/api/search-image?query=wellness%20spa%20brand%20identity%20design%20with%20sage%20green%20and%20cream%20colors%20showing%20business%20cards%20stationery%20and%20packaging%20on%20clean%20white%20surface%20soft%20natural%20lighting%20minimalist%20aesthetic&width=600&height=400&seq=port-svc-5&orientation=landscape'
    },
    {
      id: 6,
      title: 'Moderno Fashion Ads',
      client: 'Moderno Fashion',
      category: 'paid-ads',
      result: '4.2x ROAS achieved',
      image: 'https://readdy.ai/api/search-image?query=luxury%20fashion%20brand%20paid%20advertising%20campaign%20mockup%20showing%20Meta%20ads%20dashboard%20with%20performance%20metrics%20elegant%20black%20and%20white%20imagery%20professional%20marketing%20analytics%20display&width=600&height=400&seq=port-svc-6&orientation=landscape'
    }
  ];

  const portfolioFilters = [
    { label: 'All Work', value: 'all' },
    { label: 'Branding', value: 'branding' },
    { label: 'Web Design', value: 'web-design' },
    { label: 'Social Media', value: 'social-media' },
    { label: 'Video', value: 'video' },
    { label: 'Paid Ads', value: 'paid-ads' }
  ];

  const filteredPortfolio = activeFilter === 'all' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeFilter);

  return (
    <div className="min-h-screen bg-white">
      <ServiceNavbar />
      
      {/* Hero Section */}
      <section className="relative min-h-[600px] flex items-center pt-28">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Modern%20creative%20marketing%20agency%20office%20with%20team%20collaborating%20on%20digital%20campaigns%2C%20large%20screens%20showing%20social%20media%20content%2C%20teal%20and%20mint%20green%20accent%20lighting%20throughout%20space%2C%20contemporary%20minimalist%20design%20with%20plants%20and%20glass%20walls%2C%20warm%20natural%20lighting&width=1920&height=800&seq=services-hero-1&orientation=landscape"
            alt="Our Services"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/80 to-slate-900/40"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20 w-full">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#00989e]/20 rounded-full mb-6">
              <i className="ri-service-line text-[#00989e]"></i>
              <span className="text-[#00b4a6] text-sm font-medium">What We Do</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Services That Drive <span className="text-[#00b4a6]">Real Growth</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              From strategy to execution, we offer comprehensive social media marketing services designed to elevate your brand and deliver measurable results.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/#contact" className="px-8 py-4 bg-[#00989e] text-white font-semibold rounded-full hover:bg-[#007a7f] transition-colors cursor-pointer whitespace-nowrap">
                Get a Free Consultation
              </Link>
              <Link to="/case-studies" className="px-8 py-4 border-2 border-white text-white font-semibold rounded-full hover:bg-white hover:text-slate-900 transition-colors cursor-pointer whitespace-nowrap">
                View Our Work
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-slate-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-[#00b4a6] mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  {stat.value}
                </div>
                <div className="text-gray-400 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 bg-[#00989e]/10 text-[#00989e] text-sm font-semibold rounded-full mb-4">
              Our Work
            </span>
            <h2 className="text-4xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Work That Speaks for Itself
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Real results from real clients. Explore how we've helped brands transform their digital presence.
            </p>
          </div>

          {/* Filter Tabs */}
          <div className="flex justify-center mb-12 overflow-x-auto pb-2">
            <div className="inline-flex bg-gray-100 rounded-full p-1 gap-1">
              {portfolioFilters.map((filter) => (
                <button
                  key={filter.value}
                  onClick={() => setActiveFilter(filter.value)}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    activeFilter === filter.value
                      ? 'bg-[#00989e] text-white shadow-lg'
                      : 'text-gray-600 hover:text-slate-900'
                  }`}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>

          {/* Portfolio Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPortfolio.map((item) => (
              <div
                key={item.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-500 hover:-translate-y-2"
              >
                <div className="relative overflow-hidden">
                  <div className="w-full h-56">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                    <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                      <div className="flex items-center gap-2 mb-2">
                        <i className="ri-bar-chart-grouped-line text-[#00b4a6]"></i>
                        <span className="text-white text-sm font-medium">{item.result}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-[#00989e] text-sm font-medium">{item.client}</span>
                    <span className="text-xs text-gray-400 uppercase tracking-wide">
                      {item.category.replace('-', ' ')}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 group-hover:text-[#00989e] transition-colors">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>

          {/* View All CTA */}
          <div className="text-center mt-14">
            <Link
              to="/case-studies"
              className="inline-flex items-center gap-2 px-8 py-4 bg-slate-900 text-white font-semibold rounded-full hover:bg-[#00989e] transition-all duration-300 hover:gap-3 cursor-pointer whitespace-nowrap"
            >
              View All Case Studies
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Our Full Suite of Services
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Everything you need to build a powerful social media presence and grow your brand online
            </p>
          </div>
          
          <div className="space-y-16">
            {services.map((service, index) => (
              <div 
                key={index} 
                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
              >
                <div className="lg:w-1/2">
                  <div className="relative rounded-2xl overflow-hidden shadow-xl">
                    <img 
                      src={service.image}
                      alt={service.title}
                      className="w-full h-[300px] object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                  </div>
                </div>
                <div className="lg:w-1/2">
                  <div className="w-14 h-14 bg-[#00989e]/10 rounded-xl flex items-center justify-center mb-6">
                    <i className={`${service.icon} text-2xl text-[#00989e]`}></i>
                  </div>
                  <h3 className="text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <div className="grid grid-cols-2 gap-3 mb-8">
                    {service.features.map((feature, fIndex) => (
                      <div key={fIndex} className="flex items-center gap-2">
                        <i className="ri-check-line text-[#00989e]"></i>
                        <span className="text-gray-700 text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <Link 
                    to={service.link}
                    className="inline-flex items-center gap-2 text-[#00989e] font-semibold hover:gap-3 transition-all cursor-pointer"
                  >
                    Learn More <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Why Brands Choose <span className="text-[#00989e]">Unuu</span>
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                We're not just another agency. We're your strategic partner in building a social media presence that truly connects with your audience and drives business growth.
              </p>
              <div className="space-y-6">
                {[
                  { icon: 'ri-team-line', title: 'Dedicated Team', desc: 'A specialized team assigned to your brand who understands your goals' },
                  { icon: 'ri-bar-chart-box-line', title: 'Data-Driven Approach', desc: 'Every decision backed by analytics and performance insights' },
                  { icon: 'ri-refresh-line', title: 'Agile & Adaptive', desc: 'Quick to pivot strategies based on trends and results' },
                  { icon: 'ri-chat-smile-2-line', title: 'Transparent Communication', desc: 'Regular updates and open dialogue throughout our partnership' }
                ].map((item, index) => (
                  <div key={index} className="flex gap-4">
                    <div className="w-12 h-12 bg-[#00989e]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-xl text-[#00989e]`}></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-1">{item.title}</h4>
                      <p className="text-gray-600 text-sm">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Creative%20marketing%20team%20having%20strategy%20meeting%20in%20modern%20office%20with%20glass%20walls%2C%20teal%20accent%20colors%20in%20decor%2C%20collaborative%20workspace%20atmosphere%2C%20natural%20lighting%2C%20professional%20yet%20friendly%20environment&width=600&height=700&seq=why-choose-1&orientation=portrait"
                alt="Why Choose Unuu"
                className="w-full h-[500px] object-cover object-top rounded-2xl shadow-xl"
              />
              <div className="absolute -bottom-8 -left-8 bg-white rounded-xl shadow-lg p-6 max-w-[280px]">
                <div className="flex items-center gap-3 mb-3">
                  <div className="flex -space-x-2">
                    <div className="w-10 h-10 rounded-full bg-[#00989e] flex items-center justify-center text-white font-bold text-sm">M</div>
                    <div className="w-10 h-10 rounded-full bg-slate-700 flex items-center justify-center text-white font-bold text-sm">J</div>
                    <div className="w-10 h-10 rounded-full bg-[#00b4a6] flex items-center justify-center text-white font-bold text-sm">S</div>
                  </div>
                  <span className="text-sm text-gray-600">+12 experts</span>
                </div>
                <p className="text-slate-900 font-semibold text-sm">Your dedicated team is ready to transform your social presence</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 bg-slate-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              How We Work
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              A proven process that delivers consistent results for every client
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { step: '01', title: 'Discovery', desc: 'Deep dive into your brand, audience, competitors, and goals to understand your unique position', icon: 'ri-search-line' },
              { step: '02', title: 'Strategy', desc: 'Develop a custom roadmap with content pillars, posting schedules, and growth tactics', icon: 'ri-route-line' },
              { step: '03', title: 'Execute', desc: 'Bring the strategy to life with compelling content and consistent community engagement', icon: 'ri-rocket-line' },
              { step: '04', title: 'Optimize', desc: 'Analyze performance data and continuously refine for better results', icon: 'ri-line-chart-line' }
            ].map((item, index) => (
              <div key={index} className="relative">
                <div className="bg-slate-800 rounded-2xl p-8 h-full hover:bg-slate-800/80 transition-colors">
                  <div className="w-12 h-12 bg-[#00989e]/20 rounded-xl flex items-center justify-center mb-6">
                    <i className={`${item.icon} text-xl text-[#00b4a6]`}></i>
                  </div>
                  <div className="text-5xl font-bold text-[#00989e]/20 mb-4">{item.step}</div>
                  <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
                </div>
                {index < 3 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-2xl text-[#00989e]/40"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-[#00989e] to-[#007a7f] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Ready to Elevate Your Brand?
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
            Let's discuss how our services can help you achieve your social media goals and drive real business growth.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/#contact" className="px-10 py-4 bg-white text-[#00989e] font-bold rounded-full hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              Schedule a Free Consultation
            </Link>
            <Link to="/case-studies" className="px-10 py-4 border-2 border-white text-white font-bold rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap">
              See Our Results
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
